<template>
  <div>
    <v-card
      max-width="960px"
      elevation="0"
      :class="!mobile() ? 'rounded-xxl' : ''"
      class="mx-auto fill-height pa-5"
      align="center"
    >
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          fill-height
          align="center"
        >
          <v-icon
            class="mx-auto pa-5"
            color="accent"
            align="center"
            size="128"
          >
            mdi-lock-open-check-outline
          </v-icon>
          <h4>
            {{ $t('unlockTitle') }}
          </h4>
          <v-card-text align="center">
            {{ $t('unlockDescription') }}
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4 "
              @click="redirectRegister()"
            >
              {{ $t('btnCreateAccount') }}
            </v-btn>
            <v-btn
              data-testid="submit-button"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="redirectLogin()"
            >
              {{ $t('login') }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";

export default {
  props: {

  },
  data () {
      return {
        activityId: this.$route.params.id,
        space: window.location.host.split('.')[0],
        pageId:this.$route.params.pageId,
        quizId:this.$route.params.quizId,
        scormId:this.$route.params.scormId,
        checklistId:this.$route.params.checklistId
      }
  },
  computed: {

  },
  methods: {
 
    redirectLogin(){
      if(this.pageId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/page/" + this.pageId
      }else if(this.quizId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/quiz/" + this.quizId
      }else if(this.scormId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/scorm/" + this.scormId
      }else if(this.checklistId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/checklist/" + this.checklistId
      }else {
           window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId;
      }
    },
    redirectRegister() {
      if(this.pageId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/page/" + this.pageId
      }else if(this.quizId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/quiz/" + this.quizId
      }else if(this.scormId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/scorm/" + this.scormId
      }else if(this.checklistId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/checklist/" + this.checklistId
      }else {
           window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId;
      }
    },
    
  },
  mixins: [repeatedMethodsMixin],
}
</script>
